import { bffApi, Currency } from "../../autogen/bff-api";
import type { EvaluationDto, GetEvaluationApiArg, UpsertPriceOverrideApiArg } from "../../autogen/bff-api";

export const tagsInvalidatedByScoreSave = (_result: unknown, error: unknown) =>
  error ? (["SourcingEvent", "BidV2"] as const) : (["SourcingEvent"] as const);

bffApi.enhanceEndpoints({
  endpoints: {
    upsertCriterionScore: {
      invalidatesTags: (result, error) => [...tagsInvalidatedByScoreSave(result, error)],
    },
    upsertPriceOverride: {
      invalidatesTags: (result, error) => [...tagsInvalidatedByScoreSave(result, error)],
      async onQueryStarted(arg: UpsertPriceOverrideApiArg, { dispatch, getState, queryFulfilled }) {
        const patches = bffApi.util
          .selectInvalidatedBy(getState(), ["SourcingEvent"])
          .filter(({ endpointName, originalArgs }) =>
            endpointName === "getEvaluation" && (originalArgs as GetEvaluationApiArg).eventId === arg.eventId,
          )
          .map(({ originalArgs }) =>
            dispatch(
              bffApi.util.updateQueryData("getEvaluation", originalArgs as GetEvaluationApiArg, (draft) =>
                applyPrice(draft, arg),
              ),
            ),
          );
        try {
          await queryFulfilled;
        } catch {
          patches.forEach((patch) => patch.undo());
        }
      },
    },
  },
});

export const applyPrice = (evaluation: EvaluationDto, arg: UpsertPriceOverrideApiArg) => {
  const { bidId, value, comment } = arg.upsertPriceOverrideRequest;
  const bid = evaluation.bids.find((candidate) => candidate.bidId === bidId);
  if (!bid) return;
  if (value == null) {
    bid.priceOverride = null;
    bid.effectivePrice = bid.price;
    return;
  }
  const price = { value, currency: bid.effectivePrice?.currency ?? bid.price?.currency ?? Currency.Nok };
  bid.priceOverride = { value: price, comment: comment ?? null, setBeforeLatestDelivery: false };
  bid.effectivePrice = price;
};
